import { JsonObject, JsonProperty } from 'json2typescript';
import { isUndefined } from 'util';

import { Archive } from './archive';
import { ArchiveNode } from './archive-node';

@JsonObject
export class ArchiveFolder extends ArchiveNode {

  @JsonProperty('name', String)
  name: string = undefined;

  // TODO:é¿åAOTç¼è¯æ¶éè¯¯ï¼åç»­è§£å³ï¼A|Bç±»åå¨htmlä¸­è§£æé®é¢ï¼
  archive: Archive;

  init(name?: string, id?: number) {
    this.name = !isUndefined(name) ? name : 'æ°å»ºæä»¶å¤¹';
    this.id = id;
    this.folder = true;
    this.parentId = -1;
  }
}
